export default "__VITE_ASSET__CZ20wV_B__"